import React from 'react';

const NotFound: React.FC = () => {
    return (
        <div className="not-found">
            page not found - think of something nice for    this
        </div>
    );
}

export default NotFound;
